module.exports = __webpack_public_path__ + "static/img/img4.36f30d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202309/img4.jpg
// module id = N62B
// module chunks = 0